import React, { useState } from 'react';
import { Quote } from 'lucide-react';
import { getBardicInspirationProfile } from '../../../shared/rules/bard.mjs';
import { asksCuttingWords, hasLoreFeature } from '../../../shared/rules/subclasses/bard/lore.mjs';
import apiFetch from '../../../utils/apiFetch';
import { notify } from '../../../utils/notification';

/** Cutting Words' one switch: tapping flips between Ask me and Off, so enemy hits only pause for a Bard who wants them to. */
export default function CuttingWordsTile({ form, characterId, charismaModifier = 0, onCharacterChange }) {
  const [busy, setBusy] = useState(false);
  if (!hasLoreFeature(form, 'cuttingWords')) return null;
  const ask = asksCuttingWords(form);
  const ready = ask && getBardicInspirationProfile(form, charismaModifier).remaining > 0;
  const flip = async () => {
    if (busy) return;
    setBusy(true);
    try {
      const response = await apiFetch(`/characters/${encodeURIComponent(String(form?._id || characterId))}/bard/cutting-words`, { method: 'PUT', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ ask: !ask }) });
      const result = await response.json().catch(() => ({}));
      if (!response.ok) throw new Error(result.message || 'Cutting Words could not be changed.');
      onCharacterChange?.(previous => ({ ...previous, classState: { ...previous.classState, bard: { ...previous.classState?.bard, cuttingWords: result.cuttingWords } } }));
    } catch (error) { notify(error.message, 'warning'); }
    finally { setBusy(false); }
  };
  return <button type="button" data-action-tile="bard:cutting-words" className={`combat-hud-resource-tile combat-hud-feature-action-tile${ready ? '' : ' combat-hud-resource-tile--dormant'}`} style={{ '--hud-resource-accent': '#c9b6ff' }}
    aria-pressed={ask} aria-label={`Cutting Words: ${ask ? 'asks you on enemy hits' : 'off'}`} title={ask ? 'You are asked when a creature you can see hits within 60 feet. Tap to turn the prompts off.' : 'Tap to be asked when an enemy hits.'} disabled={busy} onClick={flip}>
    <span className="combat-hud-resource-tile__icon" aria-hidden="true"><Quote size={20}/></span>
    <span className="combat-hud-resource-tile__name">Cutting Words</span>
    <span className="combat-hud-resource-tile__value">{ask ? 'Ask me' : 'Off'}</span>
  </button>;
}
